export const onFilterParams = (
  location,
  search,
  startDate,
  endDate,
  status,
  customerFilter,
  hasTransactions,
  hasRecurringToken,
  isRegistered
) => {
  const params = {};

  if (location === "dashboard") {
    if (startDate && !endDate) {
      params.startDate = startDate;
    } else if (endDate && !startDate) {
      params.endDate = endDate;
    } else if (startDate && endDate) {
      params.startDate = startDate;
      params.endDate = endDate;
    }
  } else if (location === "transactions") {
    if (search) {
      params.text = search;
    }
    if (status !== "any" && status !== "") {
      params.status = status;
    }
    if (startDate && endDate) {
      params.startDate = startDate;
      params.endDate = endDate;
    }
  } else if (location === "customers") {
    if (search && customerFilter !== null && customerFilter !== "") {
      params[customerFilter] = search;
    }
    if (hasTransactions) {
      params.has_transactions = hasTransactions;
      console.log("000", params.has_transactions);
    }
    if (hasRecurringToken) {
      params.has_recurring_token = hasRecurringToken;
    }
    if (isRegistered) {
      params.is_registered = isRegistered;
    }
  } else if (location === "ads") {
    if (search && adsFilter !== null && adsFilter !== "") {
      params[adsFilter] = search;
    }
    if (startDate && !endDate) {
      params.startDate = startDate;
    } else if (endDate && !startDate) {
      params.endDate = endDate;
    } else if (startDate && endDate) {
      params.startDate = startDate;
      params.endDate = endDate;
    }
  }
  return Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join("&");
};
